import {rebuildBlocks} from './helpers';

let tables;
const tablesPositions = [];

function getCoords(elem) {
    const abiturContent = $_pro('#pro-content-abitur');
    const isAbitur = abiturContent.length;

    const {body} = document;
    const docEl = document.documentElement;

    let scrollTop;
    let scrollLeft;
    if (isAbitur) {
        scrollTop = abiturContent.scrollTop();
        scrollLeft = abiturContent.scrollLeft();
    } else {
        scrollTop = window.pageYOffset || docEl.scrollTop;
        scrollLeft = window.pageXOffset || docEl.scrollLeft;
    }

    const box = elem.getBoundingClientRect();

    const clientTop = docEl.clientTop || body.clientTop || 0;
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;

    const top = box.top + scrollTop - clientTop;
    const left = box.left + scrollLeft - clientLeft;
    return {
        top,
        left,
        height: box.height,
        width: box.width,
    };
}

function getPositionsTables() {
    tables.each((i, elem) => {
        $_pro(elem).attr('data-table-id', i);
        tablesPositions[i] = getCoords(elem);

        const proResponsiveTable = $_pro(elem).closest('.pro-responsive-table')[0];
        tablesPositions[i].left += proResponsiveTable.pageXOffset || proResponsiveTable.scrollLeft;

        tablesPositions[i].theadHeight = getCoords($_pro(elem).find('thead:first')[0]).height;
    });
}

function setContainers() {
    $_pro('.container-thead').remove();
    tables.each((i, elem) => {
        const columns = [];
        const thead = $_pro(elem).find('thead');
        $_pro(thead).find('tr').each((iTr, elemTr) => {
            columns[iTr] = [];
            $_pro(elemTr).find('th').each((iTh, elemTh) => {
                const vPaddingWithBorder = ($_pro(elemTh).innerHeight() - $_pro(elemTh).height()) / 2;
                const gPaddingWithBorder = ($_pro(elemTh).innerWidth() - $_pro(elemTh).width()) / 2;
                const vBorder = ($_pro(elemTh).outerHeight() - $_pro(elemTh).innerHeight()) / 2;
                const gBorder = ($_pro(elemTh).outerWidth() - $_pro(elemTh).innerWidth()) / 2;
                const vPadding = vPaddingWithBorder - vBorder;
                const gPadding = gPaddingWithBorder - gBorder;

                columns[iTr][iTh] = {
                    vPadding,
                    gPadding,
                    height: $_pro(elemTh).height(),
                    width: getCoords(elemTh).width,
                    text: $_pro(elemTh).html(),
                    fontSize: $_pro(elemTh).css('font-size'),
                    fontFamily: $_pro(elemTh).css('font-family'),
                    color: $_pro(elemTh).css('color'),
                    backgroundColor: $_pro(elemTh).css('background-color'),
                    verticalAlign: $_pro(elemTh).css('vertical-align'),
                };
            });
        });

        const copyThead = document.createElement('thead');
        copyThead.innerHTML = $_pro(thead).html();

        $_pro(copyThead).find('tr').each((iTr, elemTr) => {
            $_pro(elemTr).find('th').each((iTh, elemTh) => {
                const cell = columns[iTr][iTh];
                $_pro(elemTh).css({
                    'padding-top': cell.vPadding,
                    'padding-left': cell.gPadding,
                    'padding-bottom': cell.vPadding,
                    'padding-right': cell.gPadding,
                    height: cell.height,
                    'font-size': cell.fontSize,
                    'font-family': cell.fontFamily,
                    width: cell.width,
                    'min-width': cell.width,
                    'max-width': cell.width,
                    color: cell.color,
                    'background-color': cell.backgroundColor,
                    'vertical-align': cell.verticalAlign,
                });
            });
        });

        const copyTable = document.createElement('table');
        copyTable.className = 'table table-bordered table-condensed';
        copyTable.style.cssText = 'margin-bottom: 0';
        copyTable.innerHTML = $_pro(copyThead).html();

        const container = document.createElement('div');
        container.className = 'container-thead';
        const {left} = tablesPositions[i];
        container.style.cssText = `position: fixed; top: 0; left: ${left
        }px; background-color: #fff; border-bottom: 1px solid #000; display: none;`;
        container.setAttribute('data-table-id', i);

        $_pro(container).html(copyTable);
        $_pro('body').append(container);

        $_pro('[data-toggle="popover"]').popover();
    });
}

export function showHideThead() {
    $_pro('.container-thead').hide();
    if (!isAccessability()) {
        const abiturContent = $_pro('#pro-content-abitur');
        const isAbitur = abiturContent.length;
        let scrollTop;
        let scrollLeft;
        if (isAbitur) {
            scrollTop = abiturContent.scrollTop();
            scrollLeft = abiturContent.scrollLeft();
        } else {
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        }
        tables.each((i, elem) => {
            const proResponsiveTable = elem.closest('div.pro-responsive-table');
            const scrollproResponsiveTable = proResponsiveTable.pageXOffset || proResponsiveTable.scrollLeft;
            if ((tablesPositions[i].top) < scrollTop
                && (tablesPositions[i].top + tablesPositions[i].height - tablesPositions[i].theadHeight) > scrollTop
            ) {
                const container = $_pro(`div[data-table-id="${i}"]`);
                container.css('left', tablesPositions[i].left - scrollLeft - scrollproResponsiveTable);
                container.show();
            }
        });
    }
}

export function initScrollTheadTable() {
    if (!isAccessability()) {
        tables = $_pro('.table-scroll-thead:visible');
        getPositionsTables();
        setContainers();
        showHideThead();
    }
}

export function isAccessability() {
    if (window.sessionStorage) {
        const accessability = window.sessionStorage.getItem('accessability');
        return !(accessability === null || accessability === '0');
    }
    return true;
}

$_pro(() => {
    initScrollTheadTable();
    $_pro(document)
        .on('click', 'a.showpart-btn-list', () => {
            if (!isAccessability()) {
                getPositionsTables();
                setContainers();
                showHideThead();
            }
        });
    $_pro(window)
        .on('resize', () => {
            if (!isAccessability()) {
                getPositionsTables();
                setContainers();
                showHideThead();
            }
        })
        .on('scroll', () => {
            if (!isAccessability()) {
                showHideThead();
            }
        });
    $_pro('.abitur-modal')
        .on('scroll', () => {
            if (!isAccessability()) {
                showHideThead();
            }
        });

    $_pro('a[data-toggle="tab"]').on('hidden.bs.tab', (e) => {
        initScrollTheadTable();
    });
    $_pro(document).on('modal-open', () => {
        initScrollTheadTable();
    });

    $_pro('.pro-responsive-table').on('scroll', function () {
        if (!isAccessability()) {
            const tableId = $_pro(this).find('table:first').data('table-id');
            const scrollLeft = this.pageXOffset || this.scrollLeft;
            if (tablesPositions.length > 0) {
                $_pro(`div[data-table-id="${tableId}"]`).css('left', tablesPositions[tableId].left - scrollLeft);
            }
        }
    });

    $_pro(document).on('accessability', () => {
        if (!isAccessability()) {
            initScrollTheadTable();
        } else {
            showHideThead();
        }
        const proContent = $_pro('#pro-content');
        const isAbitur = proContent.length && proContent.hasClass('abitur');
        if (isAbitur) {
            $_pro('.block-item').css({height: '0px'});
            rebuildBlocks();
        }
    });
});
